/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Ticketsvoidtitle2Inputs */

const en_ticketsvoidtitle2 = /** @type {(inputs: Ticketsvoidtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Void ticket ${i?.reference}?`)
};

const de_ticketsvoidtitle2 = /** @type {(inputs: Ticketsvoidtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ticket ${i?.reference} ungültig machen?`)
};

/**
* | output |
* | --- |
* | "Void ticket {reference}?" |
*
* @param {Ticketsvoidtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvoidtitle2 = /** @type {((inputs: Ticketsvoidtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvoidtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvoidtitle2(inputs)
	return de_ticketsvoidtitle2(inputs)
});
export { ticketsvoidtitle2 as "ticketsVoidTitle" }